import React, { createContext, useContext } from 'react'

import _ from 'lodash'

const AbilityContext = createContext(null)

export const useAbilityContext = () => useContext(AbilityContext)
export const getAbilityContext = useAbilityContext

export const AbilityProvider = ({ ability, children }) => (
  <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
)

export const Can = ({
  I,
  do: action,
  on,
  this: subject,
  children,
  fallback = null
}) => {
  const ability = useAbilityContext()
  const actionToCheck = action || I
  const subjectToCheck = on || subject
  const allowed = ability?.can
    ? ability.can(actionToCheck, subjectToCheck)
    : true

  if (!allowed) return fallback

  return typeof children === 'function' ? children(allowed) : children
}
